export const scale = 2;

export const A4Size = {
  height: 960 * 1.5 * scale,
  width: 660 * 1.5 * scale,
};
export const margin = 16 * scale;
